import { background as AmbientBg } from "@edclub/shared-audio/media/ambient/background";
import { click_hint as ClickSound } from "@edclub/shared-audio/media/interaction/click_hint";
import { dong_1 as ResponseSound } from "@edclub/shared-audio/media/interaction/dong_1";
import { hint as HintSound } from "@edclub/shared-audio/media/interaction/hint";
import { hover_2 as HoverSound } from "@edclub/shared-audio/media/interaction/hover_2";

export const Sfx = {
  AmbientBg,
  HintSound,
  ClickSound,
  ResponseSound,
  HoverSound,
};

export function playAudio(audio: (typeof Sfx)[keyof typeof Sfx]) {
  if (!audio) {
    return;
  }

  window.approuter.playAudio(audio);
}
